// extracted by mini-css-extract-plugin
export default {"infoCardContainer":"inverter-info-card_infoCardContainer__8OU92","background1":"inverter-info-card_background1__kHgfa"};